import { connect } from 'react-redux';
import EventsList from './EventsList';
import { EVENTS_ROUTER_NEW, EVENTS_ROUTER_EDIT } from '../constants';
import { push } from 'react-router-redux/lib/actions';
import CRUDActions from '../../../actions/event';
import {
  listStateFromCRUD,
  listDispatchFromCrud
} from '../../../selectors/crud';
import { setHeaderTitle } from '../../../actions/layout';
import { getCurrentClubId } from '../../../selectors/club-settings';

export default connect(
  state => ({
    headerTitle: 'Events',
    ...listStateFromCRUD(state.event),
    filter: {
      club_id: getCurrentClubId(state)
    }
  }),
  dispatch => ({
    updateHeaderTitle: title => dispatch(setHeaderTitle(title)),
    ...listDispatchFromCrud(dispatch, CRUDActions),
    edit: id => dispatch(push(EVENTS_ROUTER_EDIT.replace(':id', id))),
    add: () => dispatch(push(EVENTS_ROUTER_NEW))
  }),
)(EventsList);



// WEBPACK FOOTER //
// ./src/components/Events/EventsList/index.js